export enum LoggedInMissingPointsFormField {
  AIRLINE = 'airline',
  ARRIVAL_AIRPORT = 'destinationAirport',
  BOOKING_CLASS = 'bookingClassSold',
  DEPARTURE_AIRPORT = 'originAirport',
  FLIGHT_DATE = 'flightDate',
  FLIGHT_NUMBER = 'flightNumber',
  NO_TICKET_NUMBER = 'noTicketNumber',
  SEQUENCE_NUMBER = 'sequenceNumber',
  TICKET_NUMBER = 'ticketNumber',
}

export enum LoggedOutMissingPointsFormField {
  AIRLINE = 'airline',
  ATTACHMENT = 'attachment',
  PASSENGER_NAME = 'passengerName',
  MEMBER_NUMBER = 'memberNumber',
  TICKET_NUMBER = 'ticketNumber',
  FLIGHT_FROM = 'flightFrom',
  FLIGHT_TO = 'flightTo',
  DEPARTURE_DATE = 'departureDate',
  RETURN_DATE = 'returnDate',
  FLIGHT_NUMBERS = 'flightNumbers',
  FLIGHT_NUMBER = 'flightNumber',
  COMPANIONS = 'companions',
  COMPANION_NAME = 'companionName',
  COMPANION_MEMBER_NUMBER = 'companionMemberNumber',
  MESSAGE = 'message',
  EMAIL = 'email',
  PHONE = 'phone',
  BOOKING_CLASS = 'bookingClass',
}
